
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-200 rounded-lg whitespace-nowrap cursor-pointer';
  
  const variantClasses = {
    primary: 'bg-[#2A2A2A] text-white hover:bg-[#1A1A1A] focus:ring-2 focus:ring-[#2A2A2A] focus:ring-offset-2',
    secondary: 'bg-[#F5F1E6] text-[#2A2A2A] hover:bg-[#E8E3D6] focus:ring-2 focus:ring-[#F5F1E6] focus:ring-offset-2',
    ghost: 'bg-transparent text-[#2A2A2A] hover:bg-[#F5F1E6] focus:ring-2 focus:ring-[#F5F1E6] focus:ring-offset-2'
  };
  
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-xs sm:text-sm',
    lg: 'px-6 py-3 text-sm'
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      style={{ fontFamily: 'Inter, Noto Sans SC, sans-serif' }}
      {...props}
    >
      {children}
    </button>
  );
}